import { Instance } from "flatpickr/dist/types/instance";
import { DateOption } from "flatpickr/dist/types/options";

export const formatDateValue = (
  instance: Instance,
  val: DateOption | DateOption[],
) => {
  const dateFormat = instance.config.dateFormat;

  if (Array.isArray(val)) {
    return val.map((date) => {
      if (date instanceof Date) {
        return instance.formatDate(date, dateFormat);
      }
      return date;
    });
  } else if (val instanceof Date) {
    return instance.formatDate(val, dateFormat);
  }

  return val;
};

export const formatAndSetValue = (
  instance: Instance,
  val: DateOption | DateOption[] | "",
) => {
  if (!instance) {
    console.error("Flatpickr instance not found");
    return;
  }

  if (val === "") {
    instance.clear();
    return;
  }

  const formattedValue = formatDateValue(instance, val);

  instance.setDate(formattedValue, false);
};

